import React from 'react';
import { Modal } from './Modal';
interface Props {
  open: boolean;
  onClose: () => void;
}
export function ExitIntentModal({
  open,
  onClose
}: Props) {
  return <Modal open={open} onClose={onClose} maxWidth="max-w-lg" data-id="element-18">
      <div className="text-center py-6 px-2" data-id="element-19">
        <div className="text-5xl mb-4" aria-hidden data-id="element-20">
          ⚠️
        </div>
        <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-3" data-id="element-21">
          Wait! Don't leave yet
        </h2>
        <p className="text-base md:text-lg text-gray-700 mb-6 leading-relaxed" data-id="element-22">
          You're one step away from saving thousands of dollars with the debt
          relief program in the next months.
        </p>
        <div className="flex flex-col gap-3" data-id="element-23">
          <a href="https://trackrq.dailyhomewellness.com/click" className="block w-full bg-[#4AA3D1] hover:bg-[#3D93C0] text-white text-lg font-bold py-3 rounded shadow-sm transition-colors text-center" data-id="element-24">
            YES, CONTINUE
          </a>
          <button type="button" onClick={onClose} className="text-sm text-gray-500 hover:text-gray-700 underline" data-id="element-25">
            No thanks, I want to leave
          </button>
        </div>
      </div>
    </Modal>;
}